import { ThemeExtensionDefinition, resolver, PixelValue } from "@animech/ui";

export type ThemeExtensions = {
	app: {
		viewport: {
			padding: PixelValue;
			mobilePadding: PixelValue;
			offset: PixelValue;
			lineHeight: PixelValue;
		};
		logo: {
			height: PixelValue;
			marginVertical: PixelValue;
			mobileMarginVertical: PixelValue;
		};
		panels: {
			overlayBackground: string;
			transitionDuration: number;
			transitionTimingFunction: string;
		};
		mobile: {
			minTouchTarget: PixelValue;
			panelBorderRadius: PixelValue;
			transitionDuration: number;
			transitionTimingFunction: string;
		};
		shadows: {
			dropdown: string;
			dragHandle: string;
		};
		modals: {
			maxWidth: PixelValue;
			maxWidthSmall: PixelValue;
		};
	};
};

export const themeExtensions: ThemeExtensionDefinition<ThemeExtensions> = {
	app: {
		viewport: resolver("components.container", (container) => ({
			padding: container.sizes.default.paddingHorizontal,
			mobilePadding: container.sizes.default.mobilePaddingHorizontal,
			offset: "300px",
			lineHeight: "30px",
		})),
		logo: resolver("app.viewport", (viewport) => ({
			height: "44px",
			marginVertical: viewport.padding,
			mobileMarginVertical: viewport.mobilePadding,
		})),
		panels: {
			overlayBackground: "linear-gradient(to bottom, #353535, #202020)",
			transitionDuration: 400,
			transitionTimingFunction: resolver(
				"animations.timingFunctions",
				(timingFunctions) => timingFunctions.default,
			),
		},
		mobile: {
			minTouchTarget: "44px",
			panelBorderRadius: "16px",
			transitionDuration: 300,
			transitionTimingFunction: "ease",
		},
		shadows: {
			dropdown: "0 4px 12px rgba(0, 0, 0, 0.3)",
			dragHandle: "rgba(0, 0, 0, 0.25)",
		},
		modals: {
			maxWidth: "560px",
			maxWidthSmall: "460px",
		},
	},
};
